import { z } from "zod";

export const formatValues = ["xlsx", "sav"] as const;

export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const surveyDataImportSchema = z.object({
  name: z.string({ required_error: "Please enter a survey name" }).min(1, "Please enter a survey name"),
  format: z.enum(formatValues),
  language: z.string({ required_error: "Please select a language" }).min(1, "Please select a language"),
  account_id: z.union([z.string(), z.number()], { required_error: "Please select an account" }),
  contract_id: z.string().min(1, "Please select a contract"),
});

export type FormatValue = (typeof formatValues)[number];
export type SurveyDataImportForm = z.infer<typeof surveyDataImportSchema>;
